const manageBannerAdd = {
    path: 'agentbanner/managebanner/addagentbanner',
    component: resolve => require(['@/pages/admin/ad/agentbanner/managebanner/addagentbanner.vue'], resolve),
    meta: {
        requireAuth: true
    }
}

export default manageBannerAdd